/* unplugin-vue-components disabled */import script from "./HeadMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeadMenu.vue?vue&type=style&index=0&id=33705991&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\SHBK_03_0026\\OneDrive - Microsoft 365\\桌面\\project\\jp-bk-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33705991"]])

export default __exports__